import { useMutation } from '@tanstack/react-query'
import { createCity } from '@/api/city';
import {ReturnCreateCity,CreateCityData} from "@/types"
import {PostParam} from "@/types"

export function useCreateCity(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  const mutationFn = async (data: CreateCityData) => {
    try {
      const result = await createCity(data);
      if (onSuccess) onSuccess(result);
      return result;
    } catch (error) {
      if (onError) onError(error);
      throw error; // Throw the error to keep react-query's error handling
    }
  };

  return useMutation<ReturnCreateCity, Error, CreateCityData>({
    mutationFn,
  });
}
